import { Component, Input } from "@angular/core";
import { DocumentProperty } from "../../objects/documents/CBP3461";

@Component({
    selector: 'form-input-errors',
    templateUrl:"form-input-errors.component.html",
    moduleId: module.id.toString()
})

export class FormInputErrorsComponent{

    @Input()
    public inputField: DocumentProperty;

}


// WEBPACK FOOTER //
// ./app/components/export-documents/form-input-errors.component.ts